import {useSearchParams} from 'react-router-dom';
import {useState} from 'react';

import useError from '../../hooks/useError';
import {useCompleteResetPasswordMutation} from '../../redux/services/authApi';
import CompleteResetPasswordForm from '../../components/auth/CompleteResetPasswordForm';
import AuthLayout from "../../components/auth/AuthLayout";

const handleSubmit = ({
  resetPassword,
  setIsSubmitting,
  setSuccess,
  setError,
}) => async formData => {
  setIsSubmitting(true);
  const res = await resetPassword(formData);
  setIsSubmitting(false);
  if (res.error) {
    return setError({
      message: res?.error?.data?.errors?.[0] || 'Error resetting password'
    });
  }
  return setSuccess(true);
}

const CompletePasswordResetPage = props => {
  const [success, setSuccess] = useState(false);
  const [isSubmitting,setIsSubmitting] = useState(false);
  const [search] = useSearchParams();
  const token = search.get('token');
  const errors = useError();
  const [resetPassword] = useCompleteResetPasswordMutation();
  const childProps = {
    ...props,
    success,
    isSubmitting,
    onSubmit: formData => handleSubmit({
      resetPassword,
      setIsSubmitting,
      setSuccess,
      setError: errors.create,
    })({...formData, token}),
  };
  return (
    <AuthLayout {...childProps} title='Reset Password' showLoginBtn={false}>
      <CompleteResetPasswordForm {...childProps} />
    </AuthLayout>
  );
};

export default CompletePasswordResetPage;
